/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setNotificationPreference} from '../api'

export const useMutationSetNotificationPreference = createReactQueryMutationHook('setNotificationPreference', setNotificationPreference)
